import { ProductFormConfig } from 'modules/supplier/products';
import { RTBConfigForm } from './RTBConfigForm';

export const rtbProductConfig: ProductFormConfig = {
  Component: RTBConfigForm,
  initialValues: {
    language_options: [],
    web_device_options: [],
    placement_options: [],
    format_options: [],
  },
};
